export const getFullName = (user: TUser) => `${user.firstName} ${user.lastName}`;
